<div class="lt-md:!hidden">
  <vi-toolbar color="white" [height]="85">
    <div class="toolbar" left *ngrxLet="authStore.me$ as me">
      <h3 *ngrxLet="languageStore.languageCode$ as languageCode" class="toolbar__current-date">
        {{ getDate(languageCode) }}
      </h3>
      <div class="toolbar__greeting">
        <h2 data-at-greeting>
          {{
            '+COMMERCIAL.COMMERCIAL_OVERVIEW.GREETING_EXTENDED'
              | translate: { surname: me.familyName, firstName: me.firstName }
          }}
        </h2>
        <app-connectivity-ranking
          *ngIf="authStore.connectivityRankingPositions$ | async as rankingPositions"
          [rankingPositions]="rankingPositions"
        ></app-connectivity-ranking>
      </div>
    </div>
    <nav right mat-tab-nav-bar [tabPanel]="tabPanel" *appForCommercialUser="true">
      <ng-container *ngFor="let link of tabs">
        <a
          *ngIf="link.active"
          mat-tab-link
          [routerLink]="link.value"
          routerLinkActive
          #rla="routerLinkActive"
          [active]="rla.isActive"
          >{{ link.name | translate }}
        </a>
      </ng-container>
    </nav>
    <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
  </vi-toolbar>
</div>
<div class="!hidden lt-md:!block" *appForCommercialUser="true">
  <vi-toolbar color="white" [height]="54">
    <nav center mat-tab-nav-bar [tabPanel]="tabPanel">
      <ng-container *ngFor="let link of tabs">
        <a
          mat-tab-link
          *ngIf="link.active"
          [routerLink]="link.value"
          routerLinkActive
          #rla="routerLinkActive"
          [active]="rla.isActive"
          >{{ link.name | translate }}
        </a>
      </ng-container>
    </nav>
    <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
  </vi-toolbar>
</div>
